// eslint-disable-next-line no-undef
const { __ } = wp.i18n

// eslint-disable-next-line no-undef
const object = vnObject

const productHit = (item, classes = '') => {
  if(!item.postId) false;
  item.isOnSale = item.attributes ? item.attributes.includes('En promotion') : item.isOnSale
  return `
    <article class="feed-product ${classes}">
        <a href="${item.url}" class="feed-product__wrapper grid">
            <div class="feed-product__image-part g-col-4 g-col-lg-12">
                <i class="feed-product__icon vn-icons-arrow_circle_right d-none-mob"></i>
                ${item.images.cards ? '<img class="feed-product__img" src="' + item.images.cards + '" alt="' + item.title + '">' : '' }
                ${item.isOnSale ? "<button class='on-sale-badge'>" + __('Promotion', 'vn') + "</button>" : ''}
            </div>
            <div class="feed-product__text-part g-col-8 g-col-lg-12">
                <div class="vn-btn-terms">
                    ${
                      item?.productCat?.length
                          ? item.productCat
                              .filter(productCat => productCat.parent === 0)
                              .map(productCat => `<button type="button">${productCat.name}</button>`)
                              .join('')
                          : ''
                    }
                </div>
                <div class="feed-product__title">
                    ${item.title}
                </div>
                <div class="feed-product__ref">
                    ${__('Reference', 'vn')} : ${item._highlightResult.productReference.value}
                </div>                
                <div class="feed-product__price">
                    
                    <div class="feed-product__price--title">
                        ${item.priceHtml ? item.priceHtml : __('On contact', 'vn') }
                    </div>
                </div>
            </div>
        </a>
    </article>
  `
}

const boatHit = (item, classes = '') => {
  return `
    <article class="feed-boat ${classes}">
        <a href="${item.url}" class="feed-boat__wrapper">
            <div class="feed-boat__image-part">
                <i class="feed-boat__icon vn-icons-arrow_circle_right d-none-mob"></i>
                ${item.images.cards ? '<img class="feed-boat__img" src="' + item.images.cards + '" alt="' + item.title + '">' : '' }
            </div>
            <div class="feed-boat__text-part">
                <div class="vn-btn-terms">
                    ${
                      item?.boatCondition?.length
                          ? item.boatCondition.map((boatCondition) => {
                              return `<button type="button">${boatCondition.name}</button>`
                          })
                          : ''
                    }  
                </div>
                <div class="feed-boat__title">
                    ${item.title}
                </div>             
                <div class="feed-boat__price">
                    <div class="feed-boat__price--sup-title">
                        ${item.isFromPrice && item.priceHtml !== '' ? __('From (incl. VAT)', 'vn') + ' :' : __('Price', 'vn') + ' :' }
                    </div>
                    <div class="feed-boat__price--title">
                        ${item.hideCardPrice || item.priceHtml === '' ? __('On contact', 'vn') : (item.priceHtml ? item.priceHtml : __('On contact', 'vn')) }
                    </div>                
                </div>
            </div>
        </a>
    </article>
  `
}

const noResult = `<div class="feed-none g-col-6">${__(
  'There were no results!',
  'vn'
)}</div>`

const productsButton = {}
productsButton.textContent = __('Load more products', 'vn')
productsButton.buttonContent = __('See more products', 'vn')

const boatsButton = {}
boatsButton.textContent = __('Load more boats', 'vn')
boatsButton.buttonContent = __('See more boats', 'vn')

export { noResult, productHit, productsButton, boatHit, boatsButton }
